import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { AppView, ListSection, ListItem } from 'medua-components';
import { version } from '../../../assets/version.json';

/* eslint-disable */
@translate('account')
export default class Account extends Component {

  constructor(props) {
    super(props);

    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout() {
    this.props.firebase.logout();
  }

  render() {
    return (
      <AppView
        headerSize="large"
        background="default-photo"
        title={ this.props.auth.displayName || this.props.auth.email }
        className="account"
      >
        <ListSection
          title="Account" >
          <ListItem
            key="1"
            url="/account/settings"
            title={ this.props.t('account:settings.title') }
            icon="settings" />
          <ListItem
            key="2"
            url="/account/edit"
            title={ this.props.t('account:edit.title') }
            icon="contact" />
          <ListItem
            key="3"
            url="/account/school"
            title={ this.props.t('account:school.title') }
            icon="school" />
          <ListItem
            key="4"
            url="/account/password"
            title={ this.props.t('account:change-password.title') }
            icon="password" />
          <ListItem
            key="5"
            url="/account/billing"
            title={ this.props.t('account:billing.title') }
            icon="billing" />
          <ListItem
            key="6"
            handleClick={ this.handleLogout }
            title={ this.props.t('account:logout.title') }
            icon="logout" />
        </ListSection>
        <ListSection
          title="Application" >
          <ListItem
            key="10"
            url="/account/legal"
            title={ this.props.t('account:legal.title') }
            icon="terms" />
          <ListItem
            key="11"
            url="/account/privacy"
            title={ this.props.t('account:privacy.title') }
            icon="privacy" />
          <ListItem
            key="12"
            url="/account/help"
            title={ this.props.t('account:help.title') }
            icon="help" />
        </ListSection>
        <div className="app-view-version">
          { version.version }
        </div>
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/index.jsx